const AppRoutes = {
    ROOT: "/",
    IMPRINT: "/impressum",
    PRIVACY: "/datenschutz"
}

export default AppRoutes;